import { MultiSelect } from 'primereact/multiselect'
import './CustomMultiSelect.css'

function CustomMultiSelect({ selectedOptions, setSelectedOptions, filteredOptions, placeholder, className, disabled, onChange = undefined, maxSelectedLabels, display }) {
    return (
        <div className="custom-multi-select-relative-wrapper">
          <MultiSelect
              value={selectedOptions}
              options={filteredOptions}
              optionLabel="label"
              onChange={(e) => { 
                setSelectedOptions(e.value);
                if(typeof onChange === 'function') {
                  onChange(e.value);
                }
              }}
              filter
              placeholder={placeholder}
              className={`custom-multiselect ${className || ''}`}
              emptyFilterMessage="Não foram encontradas opções com estes filtros"
              emptyMessage="Não há opções para selecionar"
              disabled={disabled}
              maxSelectedLabels={maxSelectedLabels || 3}
              selectedItemsLabel="{0} itens selecionados"
          />
        </div>
      )
}

export default CustomMultiSelect